export default __webpack_public_path__ + "static/media/neet_mweb_banner_asset.85019574.png";